import { ActionIcon, Box, Group, Text, createStyles } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
	IconBrandGmail,
	IconBrandInstagram,
	IconBrandLinkedin,
	IconBrandTwitterFilled,
} from "@tabler/icons-react";
import { Fade } from "react-reveal";

const Footer = () => {
	const { classes } = useStyle();
	const mediumScreen = useMediaQuery("(max-width: 786px)");

	return (
		<Box className={classes.footer} py="lg">
			<Fade bottom>
				<Group position="apart" className={classes.link}>
					<Text color="white" mr={mediumScreen ? 0 : 400}>
						Connect with Meena:{" "}
					</Text>
					<Group>
						<ActionIcon
							component="a"
							href="https://instagram.com/Mimi_Adebadejo"
							variant="transparent"
							target="_blank"
						>
							<IconBrandInstagram color="white" size={24} />
						</ActionIcon>
						<ActionIcon
							component="a"
							href="https://www.linkedin.com/in/aminat-adebadejo-009b06215/"
							variant="transparent"
							target="_blank"
						>
							<IconBrandLinkedin color="white" size={24} />
						</ActionIcon>
						<ActionIcon
							component="a"
							href="https://www.twitter.com/AminaAdebadejo"
							variant="transparent"
							target="_blank"
						>
							<IconBrandTwitterFilled color="white" size={24} />
						</ActionIcon>
						<ActionIcon
							component="a"
							href="mailto:adebadejoaderinsola@gmail.com"
							variant="transparent"
							target="_blank"
						>
							<IconBrandGmail color="white" size={24} />
						</ActionIcon>
					</Group>
				</Group>
				<Text mt="xl" fw="bold" color="gray" pb="md">
					Developed by{" "}
					<Text
						component="a"
						href="https://somadedaniel.netlify.app/"
						target="_blank"
						color="blue"
					>
						Daniel Somade
					</Text>
				</Text>
			</Fade>
		</Box>
	);
};

export default Footer;

const useStyle = createStyles((theme) => ({
	footer: {
		background: theme.colors.main[4],
		color: theme.colors.white,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	link: {
		[`@media (max-width: 568px)`]: {
			display: "flex",
			flexDirection: "column",
		},
	},
}));
